import 'react-loading-skeleton/dist/skeleton.css';
import Image from 'next/image';
import Link from 'next/link';
import React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

import { HomeContentEntity } from '../../domain/entities/HomeContentEntity';
import { ARROW_ICON } from '../view-model/HomeVMMapper';

import styles from '../styles/EnterpriseV2.module.scss';

import EnterpriseGrowthCardCmp from './EnterpriseGrowthCardCmp';

interface EnterpriseBannerCmpProps {
  is_loading?: boolean;
  link: string;
  is_enterprise_v2_enabled?: boolean;
  page_data: HomeContentEntity;
}

function EnterpriseBannerCmp({
  is_loading = false,
  link,
  is_enterprise_v2_enabled = false,
  page_data,
}: EnterpriseBannerCmpProps): React.ReactElement {
  if (is_loading) {
    return (
      <div className={styles['banner-wrapper']}>
        <SkeletonTheme
          baseColor="#e6e6e6"
          duration={2.0}
          highlightColor="#FEFEFE"
        >
          <Skeleton
            height="7.7rem"
            borderRadius="1.2rem"
            containerClassName={styles['skeleton-1']}
          />
        </SkeletonTheme>
      </div>
    );
  }

  if (is_enterprise_v2_enabled && page_data.enterprise_banner.text !== '') {
    return (
      <div className={styles['banner-wrapper']}>
        <Link href={link} className={styles['banner-text-wrapper']}>
          <h1 className={styles['banner-text']}>
            {page_data.enterprise_banner.text}
          </h1>
          <h1 className={styles['banner-subtext']}>
            {page_data.enterprise_banner.sub_text}
          </h1>
          <div className={styles['arrow-icon']}>
            <Image
              src={page_data.enterprise_banner.image.path}
              height={ARROW_ICON.height}
              width={ARROW_ICON.width}
              alt={ARROW_ICON.alt}
            />
          </div>
        </Link>
      </div>
    );
  }

  return (
    <EnterpriseGrowthCardCmp
      section_data={page_data.enterprise_home_section}
    />
  );
}

export default EnterpriseBannerCmp;
